import { MyDataScope } from 'mormaii-web-presentation/my-data'
import type { ViewFactory } from 'wdc-cube-solid'

import { MyDataView } from './v-my-data'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(MyDataScope, MyDataView)
}

export { MyDataView }
